import { SVGProps } from 'react';

export const CouchLamp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={41} height={40} fill="none" {...props}>
    <path fill="url(#a)" d="M28.497 35.769h2.51v2.095h-2.51v-2.095Z" />
    <path fill="url(#b)" d="M4.826 35.769h2.51v2.095h-2.51v-2.095Z" />
    <path
      fill="#447AC9"
      d="M6.281 23.171c0-.862.7-1.562 1.563-1.562h8.535c.862 0 1.562.7 1.562 1.562v8.418H6.281V23.17Z"
    />
    <path
      fill="url(#c)"
      d="M6.281 23.171c0-.862.7-1.562 1.563-1.562h8.535c.862 0 1.562.7 1.562 1.562v8.418H6.281V23.17Z"
    />
    <path
      fill="url(#d)"
      d="M6.281 23.171c0-.862.7-1.562 1.563-1.562h8.535c.862 0 1.562.7 1.562 1.562v8.418H6.281V23.17Z"
    />
    <path
      fill="url(#e)"
      d="M6.281 23.171c0-.862.7-1.562 1.563-1.562h8.535c.862 0 1.562.7 1.562 1.562v8.418H6.281V23.17Z"
    />
    <path
      fill="url(#f)"
      d="M6.281 23.171c0-.862.7-1.562 1.563-1.562h8.535c.862 0 1.562.7 1.562 1.562v8.418H6.281V23.17Z"
    />
    <path
      fill="url(#g)"
      d="M6.281 23.171c0-.862.7-1.562 1.563-1.562h8.535c.862 0 1.562.7 1.562 1.562v8.418H6.281V23.17Z"
    />
    <path
      fill="#447AC9"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#h)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#i)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#j)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#k)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#l)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#m)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <path
      fill="url(#n)"
      d="M29.601 23.171c0-.862-.7-1.562-1.562-1.562h-8.535c-.863 0-1.563.7-1.563 1.562v8.418h11.66V23.17Z"
    />
    <g filter="url(#o)">
      <path
        fill="#4A7ED9"
        d="M6.466 30.799h22.9v4.491a1.25 1.25 0 0 1-1.25 1.25H7.717a1.25 1.25 0 0 1-1.25-1.25V30.8Z"
      />
      <path
        fill="url(#p)"
        d="M6.466 30.799h22.9v4.491a1.25 1.25 0 0 1-1.25 1.25H7.717a1.25 1.25 0 0 1-1.25-1.25V30.8Z"
      />
    </g>
    <g filter="url(#q)">
      <path
        stroke="#CBC9CC"
        strokeWidth={0.45}
        d="M27.825 11.433V6.678a3.125 3.125 0 0 1 3.125-3.125h1.225A3.125 3.125 0 0 1 35.3 6.678V36.16"
      />
    </g>
    <path
      stroke="url(#r)"
      strokeWidth={0.45}
      d="M27.825 11.433V6.678a3.125 3.125 0 0 1 3.125-3.125h1.225A3.125 3.125 0 0 1 35.3 6.678V36.16"
    />
    <g strokeWidth={0.15} filter="url(#s)">
      <path
        stroke="url(#t)"
        d="M27.825 11.433V6.678c0-1.727 1.417-3.125 3.167-3.125h1.243c1.75 0 3.168 1.398 3.168 3.125V36.16"
      />
      <path
        stroke="url(#u)"
        d="M27.825 11.433V6.678c0-1.727 1.417-3.125 3.167-3.125h1.243c1.75 0 3.168 1.398 3.168 3.125V36.16"
      />
    </g>
    <g filter="url(#v)">
      <path
        fill="#307ACE"
        d="M3.547 27.84a2.129 2.129 0 0 1 4.258 0v7.45a1.25 1.25 0 0 1-1.25 1.25H4.796a1.25 1.25 0 0 1-1.25-1.25l.001-7.45Z"
      />
    </g>
    <g filter="url(#w)">
      <path
        fill="url(#x)"
        d="M27.834 7.898a4.363 4.363 0 0 0-4.365 4.365v3.447c0 .52.42.938.937.938h6.855a.938.938 0 0 0 .938-.938v-3.447a4.362 4.362 0 0 0-4.365-4.365Z"
      />
      <path
        fill="url(#y)"
        d="M27.834 7.898a4.363 4.363 0 0 0-4.365 4.365v3.447c0 .52.42.938.937.938h6.855a.938.938 0 0 0 .938-.938v-3.447a4.362 4.362 0 0 0-4.365-4.365Z"
      />
      <path
        fill="url(#z)"
        d="M27.834 7.898a4.363 4.363 0 0 0-4.365 4.365v3.447c0 .52.42.938.937.938h6.855a.938.938 0 0 0 .938-.938v-3.447a4.362 4.362 0 0 0-4.365-4.365Z"
      />
    </g>
    <path
      fill="url(#A)"
      d="M32.186 37.229c-.072.344.215.635.566.635h5.15c.35 0 .637-.291.565-.635-.318-1.516-1.62-2.651-3.143-2.651-1.522 0-2.822 1.135-3.138 2.65Z"
    />
    <path
      fill="url(#B)"
      d="M32.186 37.229c-.072.344.215.635.566.635h5.15c.35 0 .637-.291.565-.635-.318-1.516-1.62-2.651-3.143-2.651-1.522 0-2.822 1.135-3.138 2.65Z"
    />
    <path
      fill="url(#C)"
      d="M32.186 37.229c-.072.344.215.635.566.635h5.15c.35 0 .637-.291.565-.635-.318-1.516-1.62-2.651-3.143-2.651-1.522 0-2.822 1.135-3.138 2.65Z"
    />
    <path
      fill="url(#D)"
      d="M32.186 37.229c-.072.344.215.635.566.635h5.15c.35 0 .637-.291.565-.635-.318-1.516-1.62-2.651-3.143-2.651-1.522 0-2.822 1.135-3.138 2.65Z"
    />
    <g filter="url(#E)">
      <path
        stroke="url(#F)"
        strokeLinecap="round"
        strokeWidth={0.5}
        d="M8.274 22.995h7.93a.313.313 0 0 1 .312.313v6.933"
      />
    </g>
    <g filter="url(#G)">
      <path
        stroke="url(#H)"
        strokeLinecap="round"
        strokeWidth={0.5}
        d="M19.972 22.975h7.93a.313.313 0 0 1 .313.313v6.935"
      />
    </g>
    <g filter="url(#I)">
      <path
        fill="#307ACE"
        d="M27.834 27.84a2.129 2.129 0 0 1 4.257 0v7.45a1.25 1.25 0 0 1-1.25 1.25h-1.757a1.25 1.25 0 0 1-1.25-1.25v-7.45Z"
      />
    </g>
    <g filter="url(#J)">
      <path fill="#4D83D2" d="M8.274 31.589h19.55v.547H8.275v-.547Z" />
    </g>
    <g filter="url(#K)">
      <path fill="url(#L)" d="M5.617 27.449a.664.664 0 0 1 1.33 0v7.695h-1.33v-7.695Z" />
    </g>
    <g filter="url(#M)">
      <path fill="url(#N)" d="M29.962 27.449a.664.664 0 0 1 1.33 0v7.695h-1.33v-7.695Z" />
    </g>
    <defs>
      <linearGradient
        id="c"
        x1={12.111}
        x2={12.111}
        y1={21.609}
        y2={23.933}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.032} stopColor="#3B77BB" />
        <stop offset={1} stopColor="#3B77BB" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={6.281}
        x2={8.625}
        y1={25.456}
        y2={25.456}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3261A8" />
        <stop offset={1} stopColor="#3261A8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={9.563}
        x2={9.563}
        y1={31.12}
        y2={29.793}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3261A8" />
        <stop offset={1} stopColor="#457BCA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="f"
        x1={18.469}
        x2={16.164}
        y1={30.651}
        y2={30.651}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1859A4" />
        <stop offset={1} stopColor="#1859A4" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={18.029}
        x2={17.385}
        y1={28.23}
        y2={28.23}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#022F89" />
        <stop offset={1} stopColor="#2A67B4" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="h"
        x1={23.771}
        x2={23.771}
        y1={21.609}
        y2={23.933}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.032} stopColor="#3B77BB" />
        <stop offset={1} stopColor="#3B77BB" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="i"
        x1={29.601}
        x2={27.257}
        y1={25.456}
        y2={25.456}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3261A8" />
        <stop offset={1} stopColor="#3261A8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="j"
        x1={26.32}
        x2={26.32}
        y1={31.12}
        y2={29.793}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3261A8" />
        <stop offset={1} stopColor="#457BCA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="k"
        x1={17.414}
        x2={19.719}
        y1={30.651}
        y2={30.651}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1859A4" />
        <stop offset={1} stopColor="#1859A4" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="l"
        x1={17.854}
        x2={18.497}
        y1={28.23}
        y2={28.23}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#022F89" />
        <stop offset={1} stopColor="#2A67B4" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="m"
        x1={29.601}
        x2={24.875}
        y1={32.605}
        y2={28.855}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.331} stopColor="#163883" />
        <stop offset={1} stopColor="#2A5AA1" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="p"
        x1={17.917}
        x2={17.917}
        y1={30.799}
        y2={32.136}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.241} stopColor="#397AC5" />
        <stop offset={1} stopColor="#397AC5" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="u"
        x1={35.403}
        x2={35.403}
        y1={34.675}
        y2={21.004}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C5C0C3" />
        <stop offset={1} stopColor="#C5C0C3" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="x"
        x1={23.259}
        x2={31.64}
        y1={13.883}
        y2={13.883}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.253} stopColor="#F89B2F" />
        <stop offset={0.789} stopColor="#FFDB4E" />
      </linearGradient>
      <linearGradient
        id="y"
        x1={29.758}
        x2={29.758}
        y1={16.648}
        y2={16.063}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA665B" />
        <stop offset={1} stopColor="#EB9434" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="C"
        x1={36.516}
        x2={36.516}
        y1={37.864}
        y2={37.41}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E68945" />
        <stop offset={1} stopColor="#E68945" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="F"
        x1={17.922}
        x2={8.824}
        y1={28.269}
        y2={28.436}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5284C7" />
        <stop offset={1} stopColor="#5284C7" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="H"
        x1={28.947}
        x2={26.731}
        y1={22.624}
        y2={27.431}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5284C7" />
        <stop offset={1} stopColor="#5284C7" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="L"
        x1={6.281}
        x2={6.281}
        y1={26.785}
        y2={34.636}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5C92DB" />
        <stop offset={1} stopColor="#5487DD" />
      </linearGradient>
      <linearGradient
        id="N"
        x1={30.627}
        x2={30.627}
        y1={26.785}
        y2={34.636}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5C92DB" />
        <stop offset={1} stopColor="#5487DD" />
      </linearGradient>
      <filter
        id="o"
        width={23.4}
        height={5.991}
        x={5.966}
        y={30.549}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.5} dy={-0.25} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.215686 0 0 0 0 0.32549 0 0 0 0 0.768627 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_18162_19294" />
      </filter>
      <filter
        id="q"
        width={8.075}
        height={32.932}
        x={27.6}
        y={3.228}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.15} dy={-0.1} />
        <feGaussianBlur stdDeviation={0.113} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.666667 0 0 0 0 0.662745 0 0 0 0 0.666667 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_18162_19294" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.1} />
        <feGaussianBlur stdDeviation={0.113} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.6 0 0 0 0 0.521569 0 0 0 0 0.596078 0 0 0 1 0" />
        <feBlend in2="effect1_innerShadow_18162_19294" result="effect2_innerShadow_18162_19294" />
      </filter>
      <filter
        id="s"
        width={8.028}
        height={32.983}
        x={27.6}
        y={3.328}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_18162_19294" stdDeviation={0.075} />
      </filter>
      <filter
        id="v"
        width={4.759}
        height={11.205}
        x={3.546}
        y={25.335}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.5} dy={-0.375} />
        <feGaussianBlur stdDeviation={0.313} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.203922 0 0 0 0 0.380392 0 0 0 0 0.745098 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_18162_19294" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.25} />
        <feGaussianBlur stdDeviation={0.313} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.235294 0 0 0 0 0.305882 0 0 0 0 0.733333 0 0 0 1 0" />
        <feBlend in2="effect1_innerShadow_18162_19294" result="effect2_innerShadow_18162_19294" />
      </filter>
      <filter
        id="w"
        width={8.98}
        height={8.75}
        x={23.469}
        y={7.898}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.25} />
        <feGaussianBlur stdDeviation={0.375} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.815686 0 0 0 0 0.560784 0 0 0 0 0.384314 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_18162_19294" />
      </filter>
      <filter
        id="E"
        width={9.242}
        height={8.246}
        x={7.774}
        y={22.495}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_18162_19294" stdDeviation={0.125} />
      </filter>
      <filter
        id="G"
        width={9.242}
        height={8.248}
        x={19.472}
        y={22.475}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_18162_19294" stdDeviation={0.125} />
      </filter>
      <filter
        id="I"
        width={4.758}
        height={11.205}
        x={27.834}
        y={25.335}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.5} dy={-0.375} />
        <feGaussianBlur stdDeviation={0.313} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.203922 0 0 0 0 0.380392 0 0 0 0 0.745098 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_18162_19294" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.25} />
        <feGaussianBlur stdDeviation={0.313} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.235294 0 0 0 0 0.305882 0 0 0 0 0.733333 0 0 0 1 0" />
        <feBlend in2="effect1_innerShadow_18162_19294" result="effect2_innerShadow_18162_19294" />
      </filter>
      <filter
        id="J"
        width={20.051}
        height={1.047}
        x={8.024}
        y={31.339}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_18162_19294" stdDeviation={0.125} />
      </filter>
      <filter
        id="K"
        width={2.08}
        height={9.109}
        x={5.241}
        y={26.41}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_18162_19294" stdDeviation={0.188} />
      </filter>
      <filter
        id="M"
        width={2.079}
        height={9.109}
        x={29.587}
        y={26.41}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_18162_19294" stdDeviation={0.188} />
      </filter>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -1.87989 2.25235 0 30.52 37.863)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#978BFF" />
        <stop offset={1} stopColor="#7F72FF" />
      </radialGradient>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -1.87989 2.25235 0 6.847 37.863)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#978BFF" />
        <stop offset={1} stopColor="#7F72FF" />
      </radialGradient>
      <radialGradient
        id="n"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(131.934 9.662 17.6) scale(1.54901 1.49237)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5289C9" />
        <stop offset={1} stopColor="#5289C9" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="r"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -14.7384 .5871 0 34.535 34.209)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#667295" />
        <stop offset={1} stopColor="#667295" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="t"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-2.45008 7.50002 -8.7748 -2.86652 35.403 4.324)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.11} stopColor="#DDDBDE" />
        <stop offset={1} stopColor="#DDDBDE" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="z"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(93.814 10.077 19.013) scale(2.93619 5.09679)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE96C" />
        <stop offset={1} stopColor="#FFD64C" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="A"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-4.14062 0 0 -4.10776 37.805 36.98)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE258" />
        <stop offset={1} stopColor="#FFAF33" />
      </radialGradient>
      <radialGradient
        id="B"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -1.36475 1.60156 0 37.121 37.585)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD96D" />
        <stop offset={1} stopColor="#FFD96D" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="D"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-164.204 20.855 16.19) scale(4.51119)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.615} stopColor="#D2852C" stopOpacity={0} />
        <stop offset={0.981} stopColor="#884B45" />
      </radialGradient>
    </defs>
  </svg>
);
export default CouchLamp;
